import { __extends, __rest, __assign } from 'tslib';
import * as React from 'react';
import { useLocalization } from '@shared-ui/localization-context';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { classNames, analyticsTracker } from 'uitk-react-utils';
import { UitkTextInput } from './uitk-text-input.esm.js';
import styles from './uitk-input.css';

var getClassNameList = classNames.bind(styles);
var FakeInput = /** @class */ (function (_super) {
    __extends(FakeInput, _super);
    function FakeInput(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            mounted: false
        };
        _this.getPlaceholderText = _this.getPlaceholderText.bind(_this);
        _this.handleClear = _this.handleClear.bind(_this);
        _this.handleChange = _this.handleChange.bind(_this);
        return _this;
    }
    FakeInput.prototype.componentDidMount = function () {
        this.setState({ mounted: true });
    };
    FakeInput.prototype.handleChange = function (e) {
        var onChange = this.props.onChange;
        if (onChange) {
            onChange(e);
        }
    };
    FakeInput.prototype.handleClear = function () {
        var handleClear = this.props.handleClear;
        if (typeof handleClear === 'function') {
            handleClear();
        }
    };
    FakeInput.prototype.getPlaceholderText = function () {
        var props = this.props;
        var result = '';
        if (props.placeholder) {
            result = props.placeholder;
        }
        else if (props.value) {
            // Uitk-field needs some placeholder as default to place label properly
            result = 'Placeholder';
        }
        return result;
    };
    FakeInput.prototype.render = function () {
        var _a;
        var mounted = this.state.mounted;
        var _b = this.props, className = _b.className, domRef = _b.domRef, analytics = _b.analytics, hasClearButton = _b.hasClearButton, icon = _b.icon, trailingIcon = _b.trailingIcon, id = _b.id, invalid = _b.invalid, label = _b.label, l10n = _b.l10n, placeholder = _b.placeholder, required = _b.required, value = _b.value, trailingText = _b.trailingText, attrs = __rest(_b, ["className", "domRef", "analytics", "hasClearButton", "icon", "trailingIcon", "id", "invalid", "label", "l10n", "placeholder", "required", "value", "trailingText"]);
        var showClearButton = mounted && hasClearButton && value;
        var buttonClassNames = getClassNameList(className, 'uitk-fake-input', 'uitk-form-field-trigger');
        var inputClassNames = getClassNameList({ 'is-hidden': mounted });
        var iconTitle = [l10n.formatText('clear'), label].join(' ');
        if (attrs.handleClear) {
            delete attrs.handleClear;
        }
        var ariaLabelParts = [];
        // Whether or not this input is required
        if (required)
            ariaLabelParts[0] = l10n.formatText('fake.input.required');
        // Provided aria-label or just the already visible label
        ariaLabelParts[1] = (_a = attrs['aria-label']) !== null && _a !== void 0 ? _a : label;
        // Visible parts of label (value/placeholder followed by optional trailing text)
        ariaLabelParts[2] = "".concat(value || placeholder || '').concat(trailingText && value ? " ".concat(trailingText) : '');
        return (React.createElement(UitkTextInput, { className: inputClassNames, id: id, invalid: invalid, label: label, required: required, onChange: this.handleChange, placeholder: this.getPlaceholderText(), value: value || '', icon: icon }, mounted && (React.createElement(React.Fragment, null,
            React.createElement("button", __assign({}, attrs, { "aria-label": ariaLabelParts.filter(function (str) { return str.length > 0; }).join(', '), className: buttonClassNames, onClickCapture: analytics && analyticsTracker.bind(this, analytics), ref: domRef, type: "button" }),
                value || placeholder,
                trailingText && value && " ".concat(trailingText),
                trailingIcon && (React.createElement(UitkIcon, { name: trailingIcon, className: getClassNameList("uitk-fake-input-right-icon"), size: UitkIconSize.SMALL }))),
            showClearButton && (React.createElement("button", { className: getClassNameList('uitk-clear-button', 'uitk-input-cta'), onClick: this.handleClear, type: "button" },
                React.createElement(UitkIcon, { id: "fake-input-clear-button", name: "cancel", size: UitkIconSize.SMALL, title: iconTitle })))))));
    };
    return FakeInput;
}(React.Component));
var UitkFakeInput = function (props) {
    var l10n = useLocalization();
    return React.createElement(FakeInput, __assign({ l10n: l10n }, props));
};

export { UitkFakeInput };
